<template>
  <div class="user-password-reset">
    <h1>Tillbakastille Passord?</h1>

    {{pass}}

    <form @submit.prevent="handleSubmit">
      <div style="border: 1px solid red" v-if="errors.any()">
        Form has errors

        {{ errors }}
      </div>

      <div>
          <label>
            Din Epost adresse
            <input type="text" v-model="pass.Email" name="Email" v-validate="'required|email'" :class="{ 'error': errors.has('Email') }">
          </label>
          <div class="error" v-if="errors.has('Email')">
            {{errors.first('Email')}}
          </div>
      </div>

      <div>
          <label>
            Nytt passord
            <input type="password" v-model="pass.Passord" name="Passord" v-validate="'required|min:6|password-secure'" ref="Passord" :class="{ 'error': errors.has('Passord') }">
          </label>
          <div class="error" v-if="errors.has('Passord')">{{errors.first('Passord') }}</div>
      </div>

      <div>
          <label>
            Nytt passord igjen
            <input type="password" v-model="pass.PassordRepeat" name="PassordRepeat" v-validate="'required|confirmed:Passord'" data-vv-as="Passord" :class="{ 'error': errors.has('PassordRepeat') }">
          </label>
          <div class="error" v-if="errors.has('PassordRepeat')">{{errors.first('PassordRepeat') }}</div>
      </div>

      <div>
        <button type="submit" class="success button" :disabled="!isSubmittable">Go</button>
        <br>
        Submittable: {{isSubmittable}}<br>
        Processing: {{processing}}
      </div>
    </form>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService'

export default {
  name: 'UserForgotPassword',
  data () {
    return {
      token: '',
      pass: {
        Email: '',
        Passord: '',
        PassordRepeat: ''
      },
      processing: false
    }
  },

  created () {
    if (this._.isEmpty(this.$route.params.token)) {
      this.$helpers.showErrorAlert('Feil', 'Ingen token for tilbakestilling av passord')

      this.$router.push({name: 'UserPasswordForgot'})
    } else {
      // Set token
      this.token = this.$route.params.token

      // Add the kunde email unique rule to our validator
      this.$validator.extend('password-secure', {
        validate: this.$helpers.passwordStrongnessRule,
        getMessage: (field, params, data) => data ? data.message : 'Passordet er ikke sikkert nok'
      })
    }
  },
  methods: {
    handleSubmit: function () {
      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Got errors - do no API request
            this.processing = false
          } else {
            // No errors, so try to save

            AuthService.resetPassword(this.token, this.pass)
              .then((response) => {
                this.$helpers.showSuccessAlert('Ditt passord har blitt oppdatert')

                this.$router.push({ name: 'UserLogin' })
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors, 'Email')

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Noe gikk galt, prøv igjen', '', 2500)
                }
              })
              .then(() => {
                this.processing = false
              })
          }
        })
    }
  },
  computed: {
    isSubmittable: function () {
      return !(this.processing || this.errors.any())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Guest/UserPasswordReset.vue